import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'
import select from './select.vue'

Vue.component('app-modalidade-grid', grid)
Vue.component('app-modalidade-edit', edit)
Vue.component('app-modalidade-select', select)
